const doc = [({"da":({"js":({"reimbursements":({"documents":({"attachment_library":"Bliagsbibliotek"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;